export enum GeneratedInteractiveQuestionType {
  Quiz = 'QUIZ_ACTIVITY',
  OpenAnswer = 'OPEN_ANSWER_ACTIVITY',
  TrueFalse = 'TRUE_FALSE_ACTIVITY',
  Sort = 'SORT_ACTIVITY',
  Survey = 'SURVEY_ACTIVITY',
  FillInTheBlanks = 'FILL_IN_THE_BLANKS_ACTIVITY',
  ShortAnswer = 'SHORT_ANSWER_ACTIVITY',
}

export type CommonInteractiveQuestionAnswerGenerated = {
  question: string;
};

// Quiz
export type QuizGeneratedInteractiveQuestionAnswer = {
  text: string;
  isCorrect: boolean;
};

export type QuizGeneratedInteractiveQuestionResponse =
  CommonInteractiveQuestionAnswerGenerated & {
    type: GeneratedInteractiveQuestionType.Quiz;
    answers: QuizGeneratedInteractiveQuestionAnswer[];
  };

// Open Answer
export type OpenAnswerGeneratedInteractiveQuestionResponse =
  CommonInteractiveQuestionAnswerGenerated & {
    type: GeneratedInteractiveQuestionType.OpenAnswer;
  };

// True False
export type TrueFalseGeneratedInteractiveQuestionResponse =
  CommonInteractiveQuestionAnswerGenerated & {
    type: GeneratedInteractiveQuestionType.TrueFalse;
    isCorrect: boolean;
  };

// Sort
export type SortInteractiveQuestionGeneratedAnswer = {
  text: string;
  correctOrder: number;
};

export type SortGeneratedInteractiveQuestionResponse =
  CommonInteractiveQuestionAnswerGenerated & {
    type: GeneratedInteractiveQuestionType.Sort;
    answers: SortInteractiveQuestionGeneratedAnswer[];
  };

// Survey
export type SurveyInteractiveQuestionGeneratedAnswer = {
  text: string;
};

export type SurveyGeneratedInteractiveQuestionResponse =
  CommonInteractiveQuestionAnswerGenerated & {
    type: GeneratedInteractiveQuestionType.Survey;
    answers: SurveyInteractiveQuestionGeneratedAnswer[];
  };

// Fill in the Blanks
export type FillInTheBlanksInteractiveQuestionGeneratedAnswer = string;

export type FillInTheBlanksGeneratedInteractiveQuestionResponse =
  CommonInteractiveQuestionAnswerGenerated & {
    type: GeneratedInteractiveQuestionType.FillInTheBlanks;
    text: string;
    answers: FillInTheBlanksInteractiveQuestionGeneratedAnswer[];
  };

// Short Answer

export type ShortAnswerInteractiveQuestionGeneratedAnswer = {
  text: string;
};
export type ShortAnswerGeneratedInteractiveQuestionResponse =
  CommonInteractiveQuestionAnswerGenerated & {
    type: GeneratedInteractiveQuestionType.ShortAnswer;
    answers: ShortAnswerInteractiveQuestionGeneratedAnswer[];
  };

export type GeneratedInteractiveQuestionResponse =
  | QuizGeneratedInteractiveQuestionResponse
  | OpenAnswerGeneratedInteractiveQuestionResponse
  | TrueFalseGeneratedInteractiveQuestionResponse
  | SortGeneratedInteractiveQuestionResponse
  | SurveyGeneratedInteractiveQuestionResponse
  | FillInTheBlanksGeneratedInteractiveQuestionResponse
  | ShortAnswerGeneratedInteractiveQuestionResponse;

export type GenerateInteractiveQuestionResponse = GeneratedInteractiveQuestionResponse[];
